import React from "react";

const sectors = [
  "Eventlocaties",
  "Keukens & badkamers",
  "Renovatiebedrijven",
  "Ramen & deuren",
  "Car detailers",
  "Clinics & praktijken",
  "Opleidingen",
  "B2B-dienstverleners",
  "Vastgoed",
  "Showrooms",
];

export const ForWho = () => {
  return (
    <section id="voor-wie" className="relative py-14 md:py-20">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.22em] font-mono-display text-[#00FFB7]">
            Voor wie
          </span>
          <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-[42px] tracking-tight leading-[1.1]">
            Voor bedrijven waar{" "}
            <span className="text-gradient-neon">elke aanvraag telt</span>
          </h2>
          <p className="mt-4 text-[#A7A7A7] text-base md:text-[17px] leading-relaxed">
            Marlea AI is vooral interessant voor bedrijven die veel vragen krijgen,
            diensten verkopen met hogere klantwaarde of bezoekers beter willen
            begeleiden vóór ze contact opnemen.
          </p>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-2.5 md:gap-3">
          {sectors.map((s, i) => (
            <span
              key={s}
              data-testid={`sector-tag-${i}`}
              className="group inline-flex items-center gap-2 rounded-full glass px-4 py-2 text-sm text-white/90 transition-colors hover:border-[#00FFB7]/35 hover:text-white"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-gradient-neon" />
              {s}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ForWho;
